import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Process, General } from '../redux/action/action';
import LogoUtp from '../assets/images/logo-utp-postgrado.png';
import { Tools } from '../utils/tools';
import ApiService from '../services/Api';
import { APIS } from '../services/Config';
import Postulant from '../models/postulant';


const mapStateToProps = (props) => { return { glo: props.general, pro: props.process } }
const mapDispatchToProps = (dispatch) => { return { general: (global) => dispatch(General(global)), process: (user) => dispatch(Process(user)) } }

class LoginComponent extends Component {

    constructor(props) {
        super(props);
        this.inputFieldNumberDocument = React.createRef();

        this.state = {
            tiposDocumentoIdentidad: [],
            next_active: false,
            max_lenght_document: 8
        }
    }

    componentDidMount() {
        let _root = this;
        if (localStorage.getItem('submissions')) {
            localStorage.removeItem('submissions');
        }

        let catalogListPromise = [];
        catalogListPromise.push(ApiService.getData(`${APIS.tiposDocumentoIdentidad}`));
        catalogListPromise.push(ApiService.getData(`${APIS.generos}`));
        catalogListPromise.push(ApiService.getData(`${APIS.estadoCivil}`));
        catalogListPromise.push(ApiService.getData(`${APIS.departamentos}`));
        catalogListPromise.push(ApiService.getData(`${APIS.institucionesEducativas}`));
        catalogListPromise.push(ApiService.getData(`${APIS.paises}`));
        catalogListPromise.push(ApiService.getData(`${APIS.tiposIngreso}`));
        catalogListPromise.push(ApiService.getData(`${APIS.tiposVivienda}`));
        catalogListPromise.push(ApiService.getData(`${APIS.gradosEstudios}`));
        catalogListPromise.push(ApiService.getData(`${APIS.gradosEstudiosAll}`));
        catalogListPromise.push(ApiService.getData(`${APIS.rubrosEmpresa}`));

        Promise.all(catalogListPromise).then((response) => {
            let _listTiposDocumentoIdentidad = response[0].data.filter(e => e.descripcionCorta !== 'SR');
            _root.props.glo.tiposDocumentoIdentidad = _listTiposDocumentoIdentidad;
            _root.props.glo.generos = response[1].data.filter(e => e.fieldValue !== '0');
            _root.props.glo.estadoCivil = response[2].data.filter(e => e.fieldValue !== '0');
            _root.props.glo.departamentos = response[3].data.filter(e => e.codigoDepartamento !== '00');
            _root.props.glo.institucionesEducativas = response[4].data;
            _root.props.glo.paises = response[5].data.filter(e => e.codigoPais !== 'NAP' &&  e.codigoPais !== 'NRE');
            _root.props.glo.tiposIngreso = response[6].data;
            _root.props.glo.tiposVivienda = response[7].data;
            _root.props.glo.gradosAcademicos = response[8].data;
            _root.props.glo.gradosEstudiosAll = response[9].data;
            _root.props.glo.rubrosEmpresa = response[10].data;

            _root.setState({ tiposDocumentoIdentidad: _listTiposDocumentoIdentidad });
            this.props.pro.tipoDocPostulante = 1;
            Tools.hidePreloader();
        }).catch(err => {
            Tools.hidePreloader();
            console.log(err);
        });
    }


    onChange = (e) => {
        e.preventDefault();
        let _target = e.target;
        this.props.pro[_target.name] = _target.value;
        let _root = this;
        if (_target.name === 'tipoDocPostulante') {
            _root.inputFieldNumberDocument.current.value = '';
            _root.setState({ max_lenght_document: (_target.value === '1') ? 8 : 15 })
        }
        this.validateActive();
    }

    onClickNext = (e) => {
        e.preventDefault();
        let _root = this;
        if (_root.state.next_active) {
            _root.props.glo.loginTarget = 'manual';
            _root.onLogin(_root.props.pro.emailPersonal);
        }

    }

    validateActive = () => {
        let _root = this;
        if (_root.props.pro.nroDocumento !== "" && _root.props.pro.tipoDocPostulante !== "" && _root.props.pro.emailPersonal !== "") {
            _root.setState({ next_active: true });
        }
    }

    onLogin(email) {
        let _root = this;
        let postulant = Postulant;
        postulant.email = email;
        postulant.name = email;
        postulant.idTipoDocumento = _root.props.pro.tipoDocPostulante;
        postulant.nroDocumento = _root.props.pro.nroDocumento;


        
        Tools.showPreloader();

        ApiService.getData(`${APIS.submissionByEmail}${email}`).then(res => {
            _root.crmValidateLogin();
            if (res.data.length > 0) {
                //let newData = {...res.data};
                // //format number sin respuesta
                // if(res.nivelAcademico === 15){
                //     newData.nivelAcademico = -1;
                // }
                localStorage.setItem('submissions', JSON.stringify(res.data));
            }
        }).catch(err => {
            Tools.hidePreloader();
            console.log(err);
        });
    }

    crmValidateLogin = () => {
        let _root = this;

        // Tools.showPreloader();
        ApiService.crmValidate({ numdoc: _root.props.pro.nroDocumento, emailPrincipal: _root.props.pro.emailPersonal })
            .then(res => {
                if (res.data.status === 0) {
                    console.log('firstvalidation',res.data);
                    //
                    // console.log( res.data.data.opportunities );
                    _root.props.glo.oportunities = res.data.data.opportunities;
                    _root.props.pro.nombres = (res.data.data.nombres !== undefined) ? res.data.data.nombres : '';
                    _root.props.pro.apellidoPaterno = (res.data.data.apellidoPaterno !== undefined) ? res.data.data.apellidoPaterno : '';
                    _root.props.pro.apellidoMaterno = (res.data.data.apellidoMaterno !== undefined) ? res.data.data.apellidoMaterno : '';
                    _root.props.pro.emailPersonal = res.data.data.emailPrincipal;
                    _root.props.pro.genero = res.data.data.genero;
                    _root.props.pro.edad = res.data.data.edad;
                    _root.props.pro.estadoCivil = res.data.data.estadoCivil;
                    _root.props.pro.idDepartamento = res.data.data.departamento;
                    _root.props.pro.idProvincia = res.data.data.provincia;
                    _root.props.pro.idDistrito = res.data.data.distrito;
                    _root.props.pro.nivelAcademico = res.data.data.nivelAcademico;
                    _root.props.pro.tipoDocPostulante = res.data.data.tipDocumento;
                    _root.props.pro.pagoformaPago = res.data.data.formaPago;
                    _root.props.pro.celular = res.data.data.movilPrincipal;
                    _root.props.pro.nroUbigeoDNI = (res.data.data.ubigeo !== undefined) ? res.data.data.ubigeo : '';
                    _root.props.pro.direccion = res.data.data.direccion;

                    ApiService.getData(`${APIS.institucionEducativaByPS}${res.data.data.institucion}`)
                        .then(resinst => {
                            if (resinst.data.id !== undefined) {
                                _root.props.pro.institucionProcedencia = resinst.data.id;
                                _root.props.pro.paisResidencia = res.data.data.pais;
                                _root.props.pro.fechaNacimiento = Tools.convertDate(res.data.data.fecNacimiento);
                                _root.props.pro.codContacto = res.data.data.codContacto;
                                _root.props.pro.laboralCentroTrabajo = res.data.data.empresa;
                                _root.props.pro.laboralCargo = res.data.data.cargo;

                                let _otherInfo = {
                                    cargo: res.data.data.cargo,
                                    profesion: res.data.data.profesion,
                                    empresa: res.data.data.empresa,
                                    rubro: res.data.data.rubro,
                                    nivelAcademico: res.data.data.nivelAcademico,
                                    institucion: resinst.data.id,
                                    tipoDocumentoEmitir: res.data.data.tipoDocumentoEmitir,
                                    formaPago: res.data.data.formaPago,
                                };

                                _root.props.glo.otherinfo = _otherInfo;

                                _root.props.glo.isLogin = true;
                                _root.props.process(_root.props.pro);
                                _root.props.general(_root.props.glo);
                                Tools.hidePreloader();
                                _root.props.navigate('/programa-interes');
                            }
                            else {
                                Tools.hidePreloader();
                            }
                        })
                        .catch(err => {
                            Tools.hidePreloader();
                        });
                }
                else {
                    Tools.hidePreloader();
                    Tools.showToaster('error', '', res.data.message, 3000);
                }
            })
            .catch(err => {
                Tools.hidePreloader();
            });
    }

    render() {
        const {
            tiposDocumentoIdentidad,
            next_active,
            max_lenght_document
        } = this.state;
        const {
            pro
        } = this.props;

        return (
            <>
                <div className="login">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-12 text-center pt-4 pb-4">
                                <img src={LogoUtp} alt='' />
                            </div>
                            <div className="col-sm-12 pb-4">
                                <h3 className="text-center text-bold">Bienvenido(a)</h3>
                            </div>
                            <div className="col-sm-12 col-md-6 btn-opacity" style={{ textAlign: 'right' }}>
                            </div>
                            <div className="col-sm-12 col-md-6" style={{ textAlign: 'left' }}>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-10 offset-md-1">
                                <div className="form-group pb-2">
                                    <label htmlFor="emailPersonal" className="pb-2">E-mail personal</label>
                                    <input type="email" className="form-control" id="emailPersonal" name="emailPersonal"
                                        onChange={this.onChange} defaultValue={pro.emailPersonal} aria-describedby="emailHelp" placeholder="Escribe tu E-mail personal" autoComplete="off" />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-10 offset-md-1">
                                <div className="form-group pb-2">
                                    <label htmlFor="doc_type" className="pb-2">DNI/CE/CI</label>
                                    <div className="input-tg-inline">
                                        <select className="form-control" id="doc_type" name="tipoDocPostulante" onChange={this.onChange} value={pro.tipoDocPostulante}>
                                            <option disabled value={-1}>Selecciona una opción</option>
                                            {
                                                tiposDocumentoIdentidad && tiposDocumentoIdentidad.map((item, i) => (
                                                    <option key={(i + 1) + 'td'} value={item.id}>{item.descripcionCorta}</option>
                                                ))
                                            }
                                        </select>
                                        <input
                                            id="doc_num"
                                            type="text"
                                            maxLength={max_lenght_document}
                                            className="form-control"
                                            name="nroDocumento"
                                            onChange={this.onChange}
                                            defaultValue={pro.nroDocumento}
                                            placeholder="Escribe el número de documento"
                                            ref={this.inputFieldNumberDocument}
                                            autoComplete="off" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-10 offset-md-1 pt-3 pb-3">
                                <button
                                    className={(next_active) ? "btn btn-primary btn-style-1" : "btn btn-primary btn-style-1 disabled"}
                                    onClick={this.onClickNext}>
                                    Ingresa al proceso de Admisión <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12 pt-3 pb-3 text-center">
                                <small><strong style={{ display: 'block', textAlign: 'justify' }}>Recuerda: Tu progreso se guarda automáticamente para que puedas completar tu admisión a tu ritmo. Si ya has empezado el proceso, inicia sesión y continúa donde lo dejaste.</strong></small>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginComponent);